// extracted by mini-css-extract-plugin
export var card = "_k8-5";
export var cardSelected = "_k8-4";
export var image = "_k8-3";
export var modal = "_k8-0";
export var modalContent = "_k8-1";
export var table = "_k8-2";